<template>
  <div v-bind:class="{ light: !dark, dark: dark }" class="loading">
    <v-icon class="spin">
      mdi-{{ icon === "default" || !icon ? "autorenew" : icon }}
    </v-icon>
    {{ text }}
  </div>
</template>
<script>
import Vue from "vue";
export default Vue.extend({
  name: "Loading",
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: "Loading"
    },
    icon: {
      type: String
    },
    spin: {
      type: Boolean,
      default: true
    }
  }
});
</script>
<style scoped>
.light,
.dark {
  font-size: 18px;
  padding: 0;
  margin: 0;
  text-align: center;
  display: block;
  width: 100%;
}

.light {
  color: rgba(0, 0, 0, 0.3);
}

.dark {
  color: rgba(255, 255, 255, 0.3);
}

.light .spin,
.dark .spin {
  animation-name: spin;
  animation-duration: 2000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  margin-top: -2px;
}

.light .v-icon {
  color: rgba(0, 0, 0, 0.3) !important;
}

.dark,
.dark .v-icon {
  color: rgba(255, 255, 255, 0.3) !important;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
